import React from 'react';
import { FeatureCarousel } from './ui/animated-feature-carousel';

const AnimatedFeatureCarousel = () => {
  // Placeholder images - these should be replaced with actual images
  const featureImages = {
    alt: "Antix Features",
    step1img1: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&h=400&fit=crop",
    step1img2: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=600&h=400&fit=crop",
    step2img1: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=600&h=400&fit=crop",
    step2img2: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&h=400&fit=crop",
    step3img: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=800&h=500&fit=crop",
    step4img: "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=800&h=500&fit=crop"
  };

  return (
    <div id="social-features" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-6 bg-[#000000]">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12 sm:mb-16 px-4">
          <h2 className="text-[28px] sm:text-[36px] md:text-[48px] font-semibold text-white mb-4 leading-tight font-['Space_Grotesk']">
            Live music, made social
          </h2>
          <p className="text-[16px] sm:text-[20px] md:text-[24px] text-gray-300 max-w-4xl mx-auto leading-relaxed">
            From finding your crew to discovering new shows together, Antix makes live music simpler, safer, and more social. Connecting real fans, not random buyers.
          </p>
          <div className="flex items-center justify-center mt-5">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ff6b35]/10 border border-[#ff6b35]/30 text-[#ff6b35] text-xs sm:text-sm font-medium tracking-wide">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b35] animate-pulse" />
              Features coming soon
            </span>
          </div>
        </div>

        <FeatureCarousel image={featureImages} />
      </div>
    </div>
  );
};

export default AnimatedFeatureCarousel;
